var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2NewDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.88 10H15v56h45V24.22L46.88 10zM56 62H19V14h26v12h11v36zM39 39h10v4H39v10h-4V43H25v-4h10V29h4v10z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_New_document.bb540fd5.svg";
export { SvgJ2NewDocument as ReactComponent };